import './boot.js' // must come first: configures the shared data layer
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { registerServiceWorker } from './pwa/registerSW.js'
import { backendName } from '@zivapp/shared'
import './styles/global.css'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
)

// Makes ZIvapp installable and work offline.
registerServiceWorker()

if (import.meta.env.DEV) {
  console.info(`[ZIvapp] backend: ${backendName()}`)
}
